// import { Box } from "@mui/material";
// import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import { AddCircle, AutoFixHigh } from "@mui/icons-material";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useAtom } from "jotai";
import IwButton from "../../components/app/IwButton";
import MaterialCanvasNotesEditor from "../../components/canvas/material-canvas-notes-editor";
import { baseAtom, setShowCanvasNotes } from "../../stores/jotai/base";
import BMCFeatureSVG from "./BMCFeatureSVG";
import { StepperCountBox } from "./common/StepperCountBox";
import { useNavigate } from "react-router-dom";
import { INITIAL_CANVAS_DATA_ATOM_VALUE } from "../../stores/jotai/canvas/canvasData";

const CanvasFrame = (props) => {
    const {canvasData = INITIAL_CANVAS_DATA_ATOM_VALUE}=props
    const [base, setBase] = useAtom(baseAtom);
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: "100%",
                p: 2,
                backgroundColor: "white",
                opacity: 0.9,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow:
                    "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)",
            }}>
            <MaterialCanvasNotesEditor fromHome={true} canvasData={canvasData}/>
            <Stack direction="column" alignItems="center" spacing={2}>

                <StepperCountBox stepperCount={1} text="Create your Canvas" />

                <BMCFeatureSVG width={"260px"} height={"inherit"} />
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 1,
                    }}>
                    <Typography variant="h6" component="div" textAlign="center" fontSize="16px">
                        Let's bring your idea to life.
                    </Typography>
                    <Typography variant="body2" textAlign="center" fontSize="15px">
                        {
                            base.team?.isAiCanvasGenerationEnabled ? "Just describe your idea, and watch AI bring your business model to life.":"Start with a blank business model canvas and customize it based on your business idea."
                        }
                    </Typography>
                </Box>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <IwButton
                        variant="outlined"
                        disabled={!base?.roleSnapshot?.isTeamMember}
                        startIcon={<AddCircle width={24} />}
                        size="large"
                        onClick={() => {
                            navigate("/canvas");
                            setShowCanvasNotes(setBase, false);
                        }}>
                        Create manually
                    </IwButton>
                {base.team?.isAiCanvasGenerationEnabled ? (
                   <Box sx={{ marginLeft: "auto" ,display: 'inline-block'}}>
                    <IwButton
                        variant="contained"
                        startIcon={<AutoFixHigh  />}
                        size="large"
                        onClick={() => {
                            setShowCanvasNotes(setBase, true);
                        }}>
                        Generate with AI
                    </IwButton>
                   </Box>
                ): null }
                </Stack>
            </Stack>
        </Box>
    );
};

export default CanvasFrame;

